export default __webpack_public_path__ + "static/media/categories1.1724312a.png";